import data from "./data.json";
// eslint-disable-next-line
export default () => {
  return data;
};
